import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type BzSpinnerSize = 'sm' | 'md' | 'lg';

/**
 * An indeterminate loading indicator.
 *
 * Carries `role="status"` and an accessible label so a screen reader
 * announces that something is loading — a bare spinning `div` announces
 * nothing at all. Override the wording through `label` when the default is
 * too vague to be useful.
 */
@Component({
  selector: 'bz-spinner',
  templateUrl: './bz-spinner.html',
  styleUrl: './bz-spinner.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BzSpinner {
  readonly size = input<BzSpinnerSize>('md');
  readonly label = input('Loading');

  protected readonly spinnerClass = computed(() => `bz-spinner bz-spinner--${this.size()}`);
}
